import {
  createWebAuthClient,
  type WebAuthClient,
} from "@majourneys/auth-client";
import { apiBaseAbsolute } from "./api-base";

// API mounts better-auth at /api/auth/*. baseURL must include the full
// mount path so the client builds /api/auth/<endpoint> correctly.
export const authClient: WebAuthClient = createWebAuthClient({
  baseURL: `${apiBaseAbsolute()}/api/auth`,
});

export const { signIn, signUp, signOut, useSession } = authClient;

/**
 * Whether the browser's auth store already holds a signed-in session, read
 * outside React (route loaders). False while the session is still loading,
 * and on the server.
 */
export function hasBrowserSession(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const state = authClient.$store.atoms.session?.get() as { data?: unknown } | undefined;
    return !!state?.data;
  } catch {
    return false;
  }
}
